import React, { useState } from "react";
import styled from "styled-components";
import Picker from "emoji-picker-react";
import { IoMdSend } from "react-icons/io";
import { BsEmojiSmileFill } from "react-icons/bs";

const ChatInput = ({ handleSendMsg }) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [msg, setMsg] = useState("");

  const handleEmoji = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleEmojiClick = (event, emoji) => {
    let message = msg;
    message += event.emoji;
    setMsg(message);
  };

  const sendChat = (e) => {
    e.preventDefault();
    if (msg.length > 0) {
      handleSendMsg(msg);
      setMsg("");
      setShowEmojiPicker(false)
    }
  };

  return (
    <Container>
      <div className="button-container">
        <div className="emoji">
          <BsEmojiSmileFill onClick={handleEmoji} />
          {showEmojiPicker && <Picker onEmojiClick={handleEmojiClick} />}
        </div>
      </div>

      <form className="inputContainer" onSubmit={sendChat}>
        <input
          type="text"
          placeholder="Type your message here"
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
        />
        <button type="submit">
          <IoMdSend />
        </button>
      </form>
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: 5% 95%;
  align-items: center;
  background-color: #080420;
  padding: 0 2rem;
  padding-bottom: 0.3rem;
  .button-container {
    width: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    gap: 1rem;
    .emoji {
      position: relative;
      svg {
        font-size: 1.5rem;
        color: #ffff00c8;
        cursor: pointer;
      }
      .EmojiPickerReact {
        position: absolute !important;
        top: -373px !important;
        height: 350px !important;
        width: 301px !important;
        background-color: #080420;
        box-shadow: 0 5px 10px #9a86f3;
        border-color: #9186f3;
      }
    }
  }
  .inputContainer {
    width: 100%;
    display: flex;
    border-radius: 2rem;
    align-items: center;
    gap: 2rem;
    background-color: #ffffff34;
    input {
      width: 90%;
      height: 60%;
      background-color: transparent;
      color: white;
      border: none;
      padding: 4px 0;
      padding-left: 24px;
      font-size: 1.2rem;
      &::selection {
        background-color: #9a86f3;
      }
      &:focus {
        outline: none;
      }
    }
    button {
      padding: 0.3rem 2rem;
      border-radius: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #9a86f3;
      border: none;
      cursor: pointer;
      &:hover{
        background-color: #7051f9;
      }
      svg {
        font-size: 1.7rem;
        color: #fff;
      }
    }
  }

  @media screen and (max-width: 540px) {
  padding: 0 1.2rem;
  .button-container {
    .emoji {
      svg {
        font-size: 1.1rem;
      }
      .EmojiPickerReact {
        position: absolute !important;
        top: -333px !important;
        height: 320px !important;
        width: 271px !important;
        .epr-header{
          height:25%;
          .epr-header-overlay{
            padding: 4px 6px;
            .epr-search-container{
              input{
                font-size:12px;
                height:34px;
              }
            }
          }
          .epr-category-nav{
            padding: 8px;
          }
        }
        .epr-body{
          .epr-emoji-list{
            li{
              .epr-emoji-category-label{
                display: none;
              }
            }
          }
        }
        .epr-preview{
          display: none;
        } 
      }
    }
  }
  .inputContainer {
    border-radius: 1rem;
    gap: 1rem;
    input {
      width: 90%;
      height: 60%;
      padding: 4px 0;
      padding-left: 24px;
      font-size: 1rem;
    }
    button {
      padding: 0.3rem 1.2rem;
      border-radius: 1rem;
      svg {
        font-size: 1.2rem;
        color: #fff;
      }
    }
  }
  }
`;

export default ChatInput;
